let styles = `<dom-module id="animation-behavior">
  <template>
    <style>
      :host {
         --element-enter: 225ms;
         --element-leave: 195ms;
      }

      @media(min-width: 768px) {
         :host {
             --element-enter: calc(225ms * 1.3);
             --element-leave: calc(195ms * 1.3);
         }
      }

      @media(min-width: 1024px) {
         :host {
             --element-enter: 150ms;
             --element-leave: 150ms;
         }
      }
    </style>
  </template>
</dom-module>`
requestAnimationFrame(function () {
  document.head.appendChild(document.createRange().createContextualFragment(styles))
})
